<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">App Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="app_date_from"/> ~ <CustomDatePicker v-model="app_date_to"/></span>

				<em class="lt_text">Received Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="received_date_from"/> ~ <CustomDatePicker v-model="received_date_to"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendor_code" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<span class="int_type mgr_15">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_15">
					<select v-model="received_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$receivedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
			</div>
			<div class="left_option">
				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="true" /> </span>

				<span class="int_type sm_int">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable border="0">
			<thead>
				<tr>
					<th width="20px;"><input type="checkbox" @change="allClick" v-model="checked" /></th>
					<th width="80px;">
						<a href="javascript:;" @click="sort('sh_dn')">Sh No{{ sortMark('sh_dn') }}</a>
					</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('application_date')">App Date{{ sortMark('application_date') }}</a>
					</th>
					<th width="80px;">Vendor Code</th>
					<th v-if="user.company_id != 'newjigu'" width="10%">LC No</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('ship_date')">Ship Date{{ sortMark('ship_date') }}</a>
					</th>
					<th width="175px;">
						<a href="javascript:;" @click="sort('arrival_date')">Arr. / ETA Date{{ sortMark('arrival_date') }}</a>
					</th>
					<th width="195px;">Status</th>
					<th width="55px;">
						<a href="javascript:;" @click="sort('carton')">Carton{{ sortMark('carton') }}</a>
					</th>
					<th width="55px;">Quantity</th>
					<th width="80px;">Amount</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('received_date')">Rcvd Date{{ sortMark('received_date') }}</a>
					</th>
					<th v-if="user.company_id != 'newjigu'" width="55px;">
						<a href="javascript:;" @click="sort('received_quantity')">Rcvd Qty{{ sortMark('received_quantity') }}</a>
					</th>
					<th v-if="user.company_id != 'newjigu'" width="90px;">Rcvd Amt</th>
					<th v-if="user.company_id != 'newjigu'" width="150px;">
						<a href="javascript:;" @click="sort('vendor_name')">Vendor Name{{ sortMark('vendor_name') }}</a>
					</th>
					<th v-if="user.company_id == 'newjigu'" idth="200px;">{{ headers.class }} Code</th>
					<th v-if="user.company_id == 'newjigu'" idth="180px;">PO #s</th>
					<th width="30px;">Closed</th>
					<th>Description</th>
					<!-- <th width="5%">Closed</th> -->
				</tr>
			</thead>
			<tbody>
				<tr v-for="shipment in shipments" v-bind:key="shipment.sh_no">
					<td class="al_center">
						<input type="checkbox" v-model="selected_sh_no" :value="shipment.sh_no" />
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectShipment(shipment)">{{ shipment.sh_dn }}</a>
					</td>
					<td class="al_left">{{ shipment.application_date }}</td>
					<td class="al_left">{{ shipment.vendor_code }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ shipment.lc_no }}</td>
					<td class="al_left">{{ shipment.shipment_date }}</td>
					<td class="al_left"><CustomDatePicker v-model="shipment.arrival_date" /><a href="javascript:;" :class="modifiable ? 'gray_bt2' : 'gray_bt2 disable_bt'" @click="updateArrivalDate(shipment)">Update</a></td>
					<td class="al_left"><input type="text" class="tbl_int ssm2_int" v-model.trim="shipment.status" /><a href="javascript:;" :class="modifiable ? 'gray_bt2' : 'gray_bt2 disable_bt'" @click="updateStatus(shipment)">Update</a></td>
					<td class="al_right">{{ shipment.carton | commaSeparated }}</td>
					<td class="al_right">{{ shipment.total_quantity | commaSeparated }}</td>
					<td class="al_right">{{ shipment.total_amount | toCurrency }}</td>
					<td class="al_left">{{ shipment.received_date }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">{{ shipment.received_quantity | commaSeparated }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">{{ shipment.received_amount | toCurrency }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left truncate" :title="shipment.vendor_name">
						<a href="javascript:;" @click="gotoPartner(shipment.vendor_code)">{{ shipment.vendor_name }}</a>
					</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate" :title="shipment.classes">{{ shipment.classes }}</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate" :title="shipment.pos">{{ shipment.pos }}</td>
					<td class="al_center">{{ shipment.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td>
					<td class="al_left truncate" :title="shipment.description">{{ shipment.description }}</td>
					<!-- <td class="al_center">{{ shipment.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td> -->
				</tr>
				<tr>
					<td :colspan="user.company_id == 'newjigu' ? 8 : 9" class="al_right"><font color="red">Total</font></td>

					<td class="al_right">
						<font color="red">{{ shipments_sum.total_quantity | commaSeparated }}</font>
					</td>
					<td class="al_right">
						<font color="red">{{ shipments_sum.total_amount | toCurrency }}</font>
					</td>
					<td></td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">
						<font color="red">{{ shipments_sum.received_quantity | commaSeparated }}</font>
					</td>
					<td v-if="user.company_id != 'newjigu'" class="al_right">
						<font color="red">{{ shipments_sum.received_amount | toCurrency }}</font>
					</td>
					<td :colspan="user.company_id == 'newjigu' ? 4 : 3"></td>
					<!-- <td></td> -->
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ shipments_sum.list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li class="mgr_15"><PageSizeSelect v-model="page_size" @input="search()" /></li>
				<li v-if="selected_sh_no.length > 0" class="mgr_10"><a href="javascript:void(0);" v-on:click="excel">Excel Export of Selected Shipment Items(s)</a></li>
				<li v-if="modifiable"><router-link :to="{ name: 'shipmentDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link></li>
			</ul>
		</div>

		<table class="list_tbl mgb_0 add_top_line" v-show="false" id="exportTable">
			<thead>
				<tr>
					<th width="2%">No</th>
					<th width="10%">Class</th>
					<th>Name</th>
					<th width="7%">Color</th>
					<th width="6%">Price</th>
					<th width="5%">Qty</th>
					<th width="7%">Amount</th>
					<th width="5%">Rcvd Qty</th>
					<th width="6%">Rcvd Amt</th>
					<th width="7%">PO No</th>
					<th width="5%">PO Price</th>
					<th width="5%">PO Qty</th>
					<th width="7%">PO Amount</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in excelItems" v-bind:key="item.sh_item_no">
					<td class="al_left">{{ index + 1 }}</td>
					<td class="al_left">{{ item.class_code }}</td>
					<td class="al_left">{{ item.name }}</td>
					<td class="al_left">{{ item.color_code }}</td>
					<td class="al_right">{{ item.unit_price }}</td>
					<td class="al_right">{{ item.quantity }}</td>
					<td class="al_right">{{ item.amount }}</td>
					<td class="al_right">{{ item.received_quantity }}</td>

					<td class="al_right">{{ item.received_amount }}</td>
					<td class="al_left">{{ item.po_dn }}</td>
					<td class="al_right">{{ item.po_unit_price }}</td>
					<td class="al_right">{{ item.po_quantity }}</td>
					<td class="al_right">{{ item.po_amount }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { daysAgo, today } from '@/utils/date';
import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiFindShipmentList, apiSelectShipmentList, apiUpdateShipmentArrivalDate, apiUpdateShipmentStatus } from '@/api/purchase/shipment.js';
import { apiGetReportTemplate, exportFile, objectToFormData, Report, reportMrtUrl } from '@/api/util';

export default {
	props: ['headers'],
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			//list_count: 0,

			sort_key: 'application_date',
			sort_direction: 'DESC',

			received_date_from: null,
			received_date_to: null,
			app_date_from: daysAgo(6),
			app_date_to: today(),
			vendor_code: null,
			//closed_yn: 'A',
			closed_yn: 'N',
			received_yn: 'A',
			itemClass: null,
			keyword: null,

			shipments: [],

			shipments_sum: {},

			excelItems: [],

			modalName: '',
			showModal: false,

			selected_sh_no: [],
			checked: false,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		PageSizeSelect,
		PartnerSelect,
		ItemClassSelect,
	},
	methods: {
		async updateStatus(shipment) {
			if (!this.modifiable) return;

			const { data } = await apiUpdateShipmentStatus(shipment);

			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateArrivalDate(shipment) {
			if (!this.modifiable) return;

			const { data } = await apiUpdateShipmentArrivalDate(shipment);

			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async excel() {
			const { data } = await apiFindShipmentList(objectToFormData({ sh_nos: this.selected_sh_no }));

			const reportTemplate = await apiGetReportTemplate('ShipmentItem', reportMrtUrl('ShipmentItem'));
			const report = new Report(reportTemplate, data, 'ShipmentItem');
			exportFile(report, 'excel');
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectShipments();
			//console.log(sort_key);
		},
		selectShipment(shipment) {
			this.$router.push({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sh_no: shipment.sh_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectShipments(pageNo);
		},
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		selectPartner() {
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			this.received_date_from = null;
			this.received_date_to = null;
			this.app_date_from = this.user.company_id == 'he' ? daysAgo(365) : daysAgo(6);
			this.app_date_to = today();
			this.closed_yn = 'A';
			this.vendor_code = null;
			this.keyword = null;
			this.itemClass = null;

			//this.selectInvoices();
			// this.dept_code = null;
		},
		allClick() {
			const vm = this;
			if (this.checked) {
				this.shipments.forEach(sh => {
					vm.selected_sh_no.push(sh.sh_no);
				});
			} else {
				vm.selected_sh_no = [];
			}
		},
		async search() {
			await this.selectShipments();
			if (this.shipments.length == 1 && this.keyword) this.$router.push({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sh_no: this.shipments[0].sh_no } });
		},
		async selectShipments(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			const { data } = await apiSelectShipmentList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				received_date_from: this.received_date_from,
				received_date_to: this.received_date_to,
				app_date_from: this.app_date_from,
				app_date_to: this.app_date_to,
				vendor_code: this.vendor_code,
				closed_yn: this.closed_yn,
				received_yn: this.received_yn,
				keyword: this.keyword,
				class_code: this.itemClass,

				from_shipment_main: true,
			});

			//console.log(data);

			this.shipments = data.shipmentList;
			//console.log(this.purchases);
			//this.list_count = data.list_count;
			this.shipments_sum = data.shipmentsSum;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.shipments_sum.list_count);

			var uri = '/purchase/shipment_main?page_no=' + this.page_no;
			if (this.sort_key) uri += '&sort_key=' + this.sort_key;
			if (this.sort_direction) uri += '&sort_direction=' + this.sort_direction;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.closed_yn) uri += '&closed_yn=' + this.closed_yn;
			if (this.received_yn) uri += '&received_yn=' + this.received_yn;
			if (this.received_date_from) uri += '&received_date_from=' + this.received_date_from;
			if (this.received_date_to) uri += '&received_date_to=' + this.received_date_to;
			if (this.app_date_from) uri += '&app_date_from=' + this.app_date_from;
			if (this.app_date_to) uri += '&app_date_to=' + this.app_date_to;
			if (this.vendor_code) uri += '&vendor_code=' + this.vendor_code;
			if (this.itemClass) uri += '&itemClass=' + this.itemClass;
			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			//const { data } = await apiIndex();
			//this.salesGroups = data.salesGroupList;
			//this.states = data.stateList;
		},
		async init() {
			//await this.index();

			if (this.user.company_id == 'he') this.app_date_from = daysAgo(365);

			if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.closed_yn) this.closed_yn = this.$route.query.closed_yn;
			if (this.$route.query.received_yn) this.received_yn = this.$route.query.received_yn;
			if (this.$route.query.received_date_from) this.received_date_from = this.$route.query.received_date_from;
			if (this.$route.query.received_date_to) this.received_date_to = this.$route.query.received_date_to;
			if (this.$route.query.app_date_from) this.app_date_from = this.$route.query.app_date_from;
			if (this.$route.query.app_date_to) this.app_date_to = this.$route.query.app_date_to;
			if (this.$route.query.vendor_code) this.vendor_code = this.$route.query.vendor_code;
			if (this.$route.query.itemClass) this.itemClass = this.$route.query.itemClass;
			this.page_size = this.$store.getters['getDefaultPageSize'];

			await this.selectShipments(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_shipment_main');
		this.$store.commit('setSubTitle', 'Purchase -> Shipment');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
